import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Center, Loader, Box } from '@mantine/core';
import { useAuth } from '../../contexts/AuthContext';
import './styles.css';

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box className="protected-route-loader">
        <Center style={{ minHeight: '100vh' }}>
          <Loader size="xl" color="violet" />
        </Center>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

